webpackJsonp([56],{

/***/ 1157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      form: {
        name: '',
        mail: '',
        region: '',
        resource: ''
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      console.log('submit!');
    }
  }
});

/***/ }),

/***/ 1309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"box-content--header container align-items-center justify-content-center hidden"},[_c('div',{staticClass:"box-content--header__img"},[_c('div',{staticClass:"img1 container align-items-center justify-content-center animation-bottom"},[_c('div',{staticClass:"img2 container align-items-center justify-content-center"},[_c('img',{attrs:{"src":__webpack_require__(658),"width":"50","alt":"Minds"}})])])]),_vm._v(" "),_c('div',{staticClass:"box-content--header__text flex-grow-1 flex-basis-400"},[_c('h2',{staticClass:"animation-top animation-delay-02"},[_vm._v("MY "),_c('span',[_vm._v("GOALS")])]),_vm._v(" "),_c('hr',{staticClass:"header-text-hr animation-top animation-delay-02"}),_vm._v(" "),_c('p',{staticClass:"animation-bottom animation-delay-04"},[_vm._v("Ajuste suas metas, para chegar até a excelência no inglês.")])])]),_vm._v(" "),_c('div',{staticClass:"box-content shadow-box box-content-border hidden min-height container justify-content-center align-items-center"},[_c('div',{staticClass:"box--item animation-bottom animation-delay-05"},[_c('h4',[_vm._v("COMING SOON")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1157);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e0c6235_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1309);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e0c6235_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 658:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// static/js/56.9677a58f7fb1836f37d6.js